const minDate = new Date();
minDate.setFullYear(minDate.getFullYear() - 100);
const maxDate = new Date();

export const validatorDateError = (_: any, value: any) => {
  if (!value) return Promise.resolve();
  const date = new Date(value);
  if (date < minDate)
    return Promise.reject(`Invalid date`);
  if (date > maxDate)
    return Promise.reject(`Invalid date`);
  if (date.toString() === 'Invalid Date')
    return Promise.reject(`Invalid date`);
  return Promise.resolve();
};